import { type EdgeId, brand } from '@ipfabric/utils';
import type { DeviceViewEdgeId } from '../deviceViewTypes';

export const getDeviceViewEntityEdgeId = (edgeId: EdgeId): DeviceViewEdgeId =>
  brand<DeviceViewEdgeId>(`edge${edgeId}`);
